<template>
  <!-- 直播回放页面 -->
  <div class="replay-page">
    <div class="main-container">
      <!-- 左侧内容区 -->
      <div class="left-section">
        <!-- 视频播放器区域 -->
        <div class="video-wrapper">
          <!-- 视频播放区域 -->
          <div class="video-player">
            <video
              ref="videoPlayer"
              class="video-element"
              :src="videoUrl"
              @timeupdate="onTimeUpdate"
              @loadedmetadata="onLoadedMetadata"
              @play="isPlaying = true"
              @pause="isPlaying = false"
            ></video>
            <!-- 关闭按钮 -->
            <div class="close-btn" @click="onClose">
              <i class="icon-close">×</i>
            </div>
          </div>
          <!-- 进度条 - 放在控制栏上方 -->
          <div
            class="progress-bar-wrapper"
            ref="progressBar"
            @mousedown="onProgressMouseDown"
            @click="onProgressClick"
          >
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: progressPercent + '%' }">
                <div class="progress-handle"></div>
              </div>
            </div>
          </div>
          <!-- 视频控制栏 -->
          <div class="video-controls">
            <!-- 播放/暂停按钮 -->
            <div class="control-left">
              <button class="play-btn" @click="togglePlay">
                <svg v-if="!isPlaying" class="icon-svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
                <svg v-else class="icon-svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                </svg>
              </button>
              <!-- 时间显示 -->
              <!-- <span class="time-display">{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span> -->
            </div>
            <!-- 右侧控制按钮 -->
            <div class="control-right">
              <!-- 音量控制 -->
              <div class="volume-control" :class="{ dragging: isDraggingVolume }">
                <button class="control-btn" title="音量" @click="toggleMute">
                  <svg v-if="!isMuted && volume > 0.5" class="icon-svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                  </svg>
                  <svg v-else-if="!isMuted && volume > 0" class="icon-svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"/>
                  </svg>
                  <svg v-else class="icon-svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73 4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
                  </svg>
                </button>
                <div class="volume-slider-wrapper">
                  <div
                    class="volume-slider"
                    ref="volumeSlider"
                    @mousedown="onVolumeMouseDown"
                    @click="onVolumeClick"
                  >
                    <div class="volume-fill" :style="{ width: (isMuted ? 0 : volume * 100) + '%' }"></div>
                  </div>
                </div>
              </div>
              <button class="control-btn" title="画中画">
                <img class="control-img" src="../../assets/fenxiang.png" alt="">
              </button>
              <button class="control-btn" title="全屏" @click="toggleFullscreen">
                <img class="control-img" src="../../assets/quanping.png" alt="">
              </button>
            </div>
          </div>
        </div>

        <!-- 视频信息区 -->
        <div class="video-info">
          <h1 class="video-title">{{ content }}</h1>
          <div class="video-meta">
            <div class="author-info">
              <div @click="quzhuboye(authorName)">
                <img class="author-avatar" :src="authorAvatar" alt="avatar" />
              </div>
              <div class="author-name">{{ authorName }}</div>
              <button class="follow-btn" :class="{ followed: isFollowed }" @click="toggleFollow">
                {{ isFollowed ? '已关注' : '关注' }}
              </button>
            </div>
            <div class="video-stats">
              <!-- <span class="view-count">{{ anchorNumber }}人看过</span>
              <span class="publish-time">{{ hot }}人喜欢</span> -->
              <button class="share-btn" :class="{ liked: isLiked }" @click="toggleLike">
                <svg class="icon-share-svg" viewBox="0 0 24 24" :fill="isLiked ? '#ff6b9d' : 'currentColor'">
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                </svg>
                {{ isLiked ? '已喜欢' : '喜欢' }}
              </button>
            </div>
          </div>
        </div>

        <!-- 评论区 -->
        <div class="comment-section">
          <div class="comment-header">
            <span class="comment-title">评论 ({{ comments.length }}条)</span>
          </div>
          <!-- 评论输入框 -->
          <div class="comment-input-wrapper">
            <input
              ref="commentInput"
              v-model="commentText"
              class="comment-input"
              placeholder="说点什么..."
              @keyup.enter="submitComment"
            />
            <button class="send-btn" @click="submitComment">发送</button>
          </div>
          <!-- 评论列表 -->
          <div class="comment-list">
            <div v-for="(comment, index) in comments" :key="index" class="comment-item">
              <div  @click="PLtr(comment.author)">
                <img class="comment-avatar" :src="comment.avatar" alt="avatar" />
              </div>
              <div class="comment-content">
                <div class="comment-author">{{ comment.author }}</div>
                <div class="comment-text">{{ comment.text }}</div>
                <div class="comment-time" v-if="comment.time">{{ comment.time }}</div>
              </div>
              <button class="comment-like" @click="likeComment(index)">
                <svg class="icon-like-svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/>
                </svg>
                <span v-if="comment.likes > 0">{{ comment.likes }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧推荐区 -->
      <div class="right-section">
        <!-- 猜你喜欢 -->
        <div class="recommend-section">
          <h3 class="section-title">猜你喜欢</h3>
          <div class="recommend-list">
            <div
              v-for="(item, index) in recommendList"
              :key="index"
              class="recommend-item"
              @click="playVideo(item)"
            >
              <div class="recommend-cover">
                <img :src="item.cover" alt="cover" />
              </div>
              <div class="recommend-info">
                <div class="recommend-title">{{ item.title }}</div>
                <div class="recommend-author">
                  <img class="recommend-avatar" :src="item.avatar" alt="avatar" />
                  <span>{{ item.author }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 广告位 -->
        <!-- <div class="ad-section">
          <div class="ad-item ad-1">
            <img src="https://via.placeholder.com/300x120/4A90D9/FFFFFF?text=未成年人不良信息举报" alt="ad" />
          </div>
          <div class="ad-item ad-2">
            <img src="https://via.placeholder.com/300x120/6B5CE7/FFFFFF?text=暑期直播间" alt="ad" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Hls from 'hls.js'

export default {
  name: 'HuifangPage',
  data() {
    return {
      //id
      huifid:1,
      // zhiboid
      zhiboid:-1,
      // 视频相关
      videoUrl: '',
      hlsInstance: null,
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      volume: 0.8,
      isMuted: false,
      isDraggingVolume: false,
      isDraggingProgress: false,
      
      // 作者信息
      authorAvatar: '',
      isFollowed: false,
      isLiked: false,
      authorName: '',
      zhuboId: '',  // 主播ID，用于关注接口
      anchorNumber: '',
      hot: '',
      fensi: '',
      content: '',
      age: '',
      xingbie: '',
      diqu: '',
      xingzuo: '',
      pid:'',
      anchorid:'',
      
      // 评论
      commentText: '',
      comments: [
        {
          avatar: 'https://via.placeholder.com/32x32/8B7355/FFFFFF?text=花',
          author: '花园小蜜蜂 🐝',
          text: '这场比赛太精彩了，长春队表现真不错！',
          likes: 0
        },
        {
          avatar: 'https://via.placeholder.com/32x32/5C8A8A/FFFFFF?text=心',
          author: '红心球迷',
          text: '呼和浩特队的防守还需要加强啊',
          likes: 0
        },
        {
          avatar: 'https://via.placeholder.com/32x32/8B4513/FFFFFF?text=球',
          author: '足球爱好者',
          text: '期待下一场对决，东北足球越来越强了',
          likes: 5
        }
      ],
      
      // 推荐列表
      recommendList: []
    }
  },
  mounted() {
    this.zhiboid =  this.$route.params.id || this.$route.query.id;
    this.huifid = this.$route.params.zhiboid || this.$route.query.zhiboid;
    console.log(this.huifid)
    // 页面加载获取数据
    this.fetchHuifangData(this.zhiboid,this.huifid)
  },
  beforeDestroy() {
    // 销毁HLS实例
    this.destroyHls()
  },
  computed: {
    progressPercent() {
      if (this.duration === 0) return 0
      return (this.currentTime / this.duration) * 100
    }
  },
  methods: {
    // 获取回放数据
    fetchHuifangData(id,pos) {
      axios.get('https://guangxing.xiangyouhulian.cn/api/index/huifang', {
        params: {
          id:id,
          pos:pos
        }
      })
        .then(response => {
          if (response.data.code === 1 && response.data.data) {
            const data = response.data.data
            // 设置左侧视频区数据
            if (data.one && data.one.length > 0) {
              this.setVideoData(data.one[0])
              // 设置评论数据（在one[0]里面）
              if (data.one[0].pinglun_list && data.one[0].pinglun_list.length > 0) {
                this.setCommentsData(data.one[0].pinglun_list)
              } else {
                this.comments = []
              }
            }
            // 设置右侧推荐区数据
            if (data.tuijian && data.tuijian.length > 0) {
              this.setRecommendData(data.tuijian)
            }
            
            // 数据加载完成后自动播放
            this.$nextTick(() => {
              this.autoPlayVideo()
            })
          }
        })
        .catch(error => {
          console.error('获取回放数据失败:', error)
        })
    },
    // 自动播放视频
    autoPlayVideo() {
      const video = this.$refs.videoPlayer
      if (!video) {
        console.log('视频元素未找到，延迟重试')
        setTimeout(() => this.autoPlayVideo(), 300)
        return
      }
      
      console.log('开始自动播放')
      video.play().then(() => {
        console.log('自动播放成功')
        this.isPlaying = true
      }).catch(err => {
        console.log('自动播放被阻止:', err)
        this.isPlaying = false
        // 某些浏览器需要用户交互后才能播放，这里保持暂停状态
      })
    },
    // 跳转到主播主页
    quzhuboye(naem){
      console.log('跳转到主播主页:', naem)
      this.$router.push(`/tr/${naem}`)
    },
    // 跳转到主播主页
    PLtr(naem){
      if(naem=='星动测试账号') return
      console.log('跳转到主播主页:', naem)
      this.$router.push(`/trpl/${naem}`)
    },
    // 设置评论数据
    setCommentsData(list) {
      this.comments = list.map(item => ({
        avatar: item.image || 'https://via.placeholder.com/32x32/666666/FFFFFF?text=用户',
        author: item.yhname || '匿名用户',
        text: item.content || '',
        time: item.shijian || '',
        likes: 0
      }))
    },
    // 设置视频数据
    setVideoData(item) {
      this.authorName = item.anchor_name || ''
      this.authorAvatar = item.touxiang || ''
      this.anchorNumber = item.anchor_number || ''
      this.hot = item.hot || ''
      this.fensi = item.fensi || ''
      this.content = item.content || ''
      this.age = item.age || ''
      this.xingbie = item.xingbie || ''
      this.diqu = item.diqu || ''
      this.xingzuo = item.xingzuo || ''
      this.zhuboId = item.id || ''  // 保存主播ID
      this.pid = item.pid,
      this.anchorid = item.anchorid
      
      // 检查是否已关注该主播
      this.checkFollowStatus()
      
      // 初始化视频播放
      this.$nextTick(() => {
        this.initVideo(item.huifang_url)
      })
    },
    // 检查关注状态
    checkFollowStatus() {
      const loginInfo = this.$store.state.LoginStorage
      if (loginInfo && loginInfo.zbid && this.zhuboId) {
        // 判断zbid数组中是否包含当前主播ID
        this.isFollowed = loginInfo.zbid.includes(parseInt(this.zhuboId)) || loginInfo.zbid.includes(this.zhuboId)
      }
      // 检查喜欢状态 - 从like数组循环判断
      if (loginInfo && loginInfo.like && this.zhuboId && loginInfo.like.length > 0) {
        const currentId = parseInt(this.zhuboId)
        this.isLiked = false
        for (let i = 0; i < loginInfo.like.length; i++) {
          if (parseInt(loginInfo.like[i]) === currentId || loginInfo.like[i] === this.zhuboId) {
            this.isLiked = true
            break
          }
        }
      }
    },
    // 设置推荐列表数据
    setRecommendData(list) {
      this.recommendList = list.map(item => ({
        id: item.id,
        cover: item.hfimage,
        title: item.content || item.anchor_name,
        avatar: item.touxiang,
        author: item.anchor_name,
        huifang_url: item.huifang_url,
        rawData: item
      }))
    },
    // 初始化视频播放
    initVideo(videoUrl) {
      if (!videoUrl) return
      
      const video = this.$refs.videoPlayer
      if (!video) return
      
      // 销毁旧实例
      this.destroyHls()
      
      // 检查是否是m3u8格式
      if (videoUrl.endsWith('.m3u8')) {
        if (Hls.isSupported()) {
          const hls = new Hls({
            debug: false,
            enableWorker: true
          })
          hls.loadSource(videoUrl)
          hls.attachMedia(video)
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            console.log('HLS manifest parsed')
          })
          hls.on(Hls.Events.ERROR, (event, data) => {
            console.error('HLS 错误:', event, data)
          })
          this.hlsInstance = hls
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          // Safari原生支持
          video.src = videoUrl
        }
      } else {
        // 普通视频格式
        video.src = videoUrl
      }
    },
    // 销毁HLS实例
    destroyHls() {
      if (this.hlsInstance) {
        this.hlsInstance.destroy()
        this.hlsInstance = null
      }
    },
    // 播放推荐视频
    playVideo(item) {
      if (item.rawData) {
        // 先暂停当前视频
        const video = this.$refs.videoPlayer
        if (video) {
          video.pause()
        }
        this.isPlaying = false
        
        // 更新URL参数并重新请求数据
        this.zhiboid = item.id
        this.huifid = 10
        this.fetchHuifangData(item.id, 10)
      }
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },
    togglePlay() {
      const video = this.$refs.videoPlayer
      if (!video) return
      
      if (this.isPlaying) {
        video.pause()
        this.isPlaying = false
        console.log('视频已暂停')
      } else {
        video.play().then(() => {
          this.isPlaying = true
          console.log('视频开始播放')
        }).catch(err => {
          console.log('播放失败:', err)
          this.isPlaying = false
        })
      }
    },
    onTimeUpdate(e) {
      this.currentTime = e.target.currentTime
    },
    onLoadedMetadata(e) {
      this.duration = e.target.duration
    },
    onProgressClick(e) {
      if (this.isDraggingProgress) return
      this.updateProgressFromEvent(e)
    },
    onProgressMouseDown(e) {
      this.isDraggingProgress = true
      this.updateProgressFromEvent(e)
      document.addEventListener('mousemove', this.onProgressMouseMove)
      document.addEventListener('mouseup', this.onProgressMouseUp)
    },
    onProgressMouseMove(e) {
      if (!this.isDraggingProgress) return
      this.updateProgressFromEvent(e)
    },
    onProgressMouseUp() {
      this.isDraggingProgress = false
      document.removeEventListener('mousemove', this.onProgressMouseMove)
      document.removeEventListener('mouseup', this.onProgressMouseUp)
    },
    updateProgressFromEvent(e) {
      const bar = this.$refs.progressBar
      if (!bar) return
      const rect = bar.getBoundingClientRect()
      const percent = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width))
      const newTime = percent * this.duration
      this.$refs.videoPlayer.currentTime = newTime
      this.currentTime = newTime
    },
    toggleFullscreen() {
      const video = this.$refs.videoPlayer
      if (video.requestFullscreen) {
        video.requestFullscreen()
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen()
      }
    },
    onClose() {
      this.$router.back()
    },
    // 关注/取消关注
    toggleFollow() {
      // 检查是否登录
      if (!this.checkLogin()) {
        this.$message.warning('请先登录后再关注')
        this.$router.push('/login')
        return
      }

      const userInfo = this.getUserInfo()
      if (!userInfo || !userInfo.id) {
        this.$message.warning('用户信息获取失败')
        return
      }

      // 请求关注接口
      axios.post('https://guangxing.xiangyouhulian.cn/api/index/zbgz', {
        yhid: userInfo.id,
        zbid: this.zhuboId,
        zbfs: this.isFollowed ? this.fensi-- : this.fensi,
        add: this.isFollowed ? '' : 'add'
      }).then(res => {
        console.log('关注接口返回:', res.data)
        if (res.data.code === 1) {
          // 存储到本地浏览器
          localStorage.setItem('TTxq', JSON.stringify(res.data.data))
          // 存储到 Vuex
          this.$store.commit('LoginModification', res.data.data)
          // 更新关注状态
          this.isFollowed = !this.isFollowed
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      }).catch(err => {
        console.log('关注请求失败:', err)
        this.$message.error('网络错误，请稍后重试')
      })
    },
    // 喜欢/取消喜欢
    toggleLike() {
      // 检查是否登录
      if (!this.checkLogin()) {
        this.$message.warning('请先登录后再喜欢')
        this.$router.push('/login')
        return
      }

      const userInfo = this.getUserInfo()
      if (!userInfo || !userInfo.id) {
        this.$message.warning('用户信息获取失败')
        return
      }

      // 请求喜欢接口
      axios.get('https://guangxing.xiangyouhulian.cn/api/index/like', {
        params: {
          yhid: userInfo.id,
          zbid: this.zhuboId,
          ziid:this.huifid,
          act: this.isLiked ? 'unlike' : 'like'
        }
      }).then(res => {
        console.log('喜欢接口返回:', res.data)
        if (res.data.code === 1 || res.data.code === 200) {
          // 存储到本地浏览器
          // localStorage.setItem('TTxq', JSON.stringify(res.data.data))
          // 存储到 Vuex
          // this.$store.commit('LoginModification', res.data.data)
          // 更新喜欢状态和喜欢人数
          if (this.isLiked) {
            this.hot = String(Number(this.hot) - 1) // 取消喜欢，人数减1
          } else {
            this.hot = String(Number(this.hot) + 1) // 添加喜欢，人数加1
          }
          this.isLiked = !this.isLiked
          // 更新本地存储和Vuex
          if (res.data.data) {
            localStorage.setItem('TTxq', JSON.stringify(res.data.data))
            this.$store.commit('LoginModification', res.data.data)
          }
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      }).catch(err => {
        console.log('喜欢请求失败:', err)
        this.$message.error('网络错误，请稍后重试')
      })
    },
    focusComment() {
      this.$refs.commentInput.focus()
    },
    // 检查是否登录
    checkLogin() {
      const loginInfo = this.$store.state.LoginStorage
      return loginInfo && loginInfo.id
    },
    // 获取登录用户信息
    getUserInfo() {
      return this.$store.state.LoginStorage
    },
    submitComment() {
      if (!this.commentText.trim()) return
      
      // 检查是否登录
      if (!this.checkLogin()) {
        this.$message.warning('请先登录后再评论')
        this.$router.push('/login')
        return
      }
      
      const userInfo = this.getUserInfo()
      const zhuboid = Number(this.$route.params.id) || Number(this.$route.query.id) || ''
      
      // 调用发送评论接口
      axios.post('https://guangxing.xiangyouhulian.cn/api/index/publish', {
        content: this.commentText.trim(),
        yhname: userInfo.username || userInfo.nickname || '',
        zhuboid: zhuboid
      }).then(response => {
        if (response.data.code === 1) {
          // 发送成功，添加到评论列表
          this.comments.unshift({
            avatar: userInfo.image || 'https://via.placeholder.com/32x32/666666/FFFFFF?text=我',
            author: userInfo.nickname || '我',
            text: this.commentText.trim(),
            time: new Date().toLocaleString(),
            likes: 0
          })
          this.commentText = ''
          this.$message.success('评论成功')
        } else {
          this.$message.error(response.data.msg || '评论失败')
        }
      }).catch(error => {
        console.error('发送评论失败:', error)
        this.$message.error('发送评论失败，请稍后重试')
      })
    },
    likeComment(index) {
      this.comments[index].likes++
    },

    toggleMute() {
      this.isMuted = !this.isMuted
      this.$refs.videoPlayer.muted = this.isMuted
    },
    onVolumeClick(e) {
      this.updateVolumeFromEvent(e)
    },
    onVolumeMouseDown(e) {
      this.isDraggingVolume = true
      this.updateVolumeFromEvent(e)
      document.addEventListener('mousemove', this.onVolumeMouseMove)
      document.addEventListener('mouseup', this.onVolumeMouseUp)
    },
    onVolumeMouseMove(e) {
      if (!this.isDraggingVolume) return
      this.updateVolumeFromEvent(e)
    },
    onVolumeMouseUp() {
      this.isDraggingVolume = false
      document.removeEventListener('mousemove', this.onVolumeMouseMove)
      document.removeEventListener('mouseup', this.onVolumeMouseUp)
    },
    updateVolumeFromEvent(e) {
      const slider = this.$refs.volumeSlider
      if (!slider) return
      const rect = slider.getBoundingClientRect()
      const percent = (e.clientX - rect.left) / rect.width
      this.volume = Math.max(0, Math.min(1, percent))
      this.$refs.videoPlayer.volume = this.volume
      if (this.volume > 0) {
        this.isMuted = false
        this.$refs.videoPlayer.muted = false
      }
    }
  }
}
</script>

<style scoped>
.replay-page {
  min-height: 100%;
  background-color: #f4f4f5;
  padding: 18px 24px 28px;
  box-sizing: border-box;
}

.main-container {
  display: flex;
  gap: 16px;
  width: 71.5%;
  margin: 0 auto;
}

.left-section {
  flex: 1;
  min-width: 0;
}

.video-wrapper {
  background-color: #18191c;
  border: 1px solid #18191c;
  border-radius: 8px;
  overflow: hidden;
}

.video-player {
  position: relative;
  width: 100%;
  /* 使用 aspect-ratio 保持 16:9 比例，响应式适应容器宽度 */
  aspect-ratio: 16 / 9;
  background-color: #000;
  overflow: hidden;
}

.video-element {
  width: 100%;
  height: 100%;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: #fb7299;
}

.icon-close {
  color: #fff;
  font-size: 20px;
  line-height: 1;
  font-style: normal !important;
}

/* 进度条 - 在控制栏上方（深色控制区） */
.progress-bar-wrapper {
  padding: 8px 16px 4px;
  background-color: #18191c;
  cursor: pointer;
}

.progress-bar {
  height: 4px;
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 2px;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: #fb7299;
  border-radius: 2px;
  position: relative;
}

.progress-handle {
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  background-color: #fb7299;
  border: 2px solid #fff;
  border-radius: 50%;
  box-sizing: border-box;
}

/* 视频控制栏（深色控制区） */
.video-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px 12px;
  background-color: #18191c;
}

.control-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.play-btn {
  width: 34px;
  height: 34px;
  border: none;
  background-color: #fb7299;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  padding: 8px;
}

.play-btn:hover {
  background-color: #ff85ad;
}

.time-display {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
}

.control-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

.control-btn {
  width: 36px;
  height: 36px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.85);
  padding: 6px;
  transition: color 0.2s;
}

.control-btn:hover {
  color: #ff85ad;
}

.icon-svg {
  width: 22px;
  height: 22px;
}

.control-img {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1) opacity(0.85);
  transition: filter 0.2s;
}

.control-btn:hover .control-img {
  filter: brightness(0) invert(1) opacity(0.85);
}

/* 音量控制 */
.volume-control {
  display: flex;
  align-items: center;
  gap: 4px;
}

.volume-slider-wrapper {
  width: 0;
  overflow: hidden;
}

.volume-control:hover .volume-slider-wrapper,
.volume-control.dragging .volume-slider-wrapper {
  width: 60px;
}

.volume-slider {
  width: 60px;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 2px;
  cursor: pointer;
  position: relative;
}

.volume-fill {
  height: 100%;
  background: #fb7299;
  border-radius: 2px;
}

/* 视频信息区（白色卡片） */
.video-info {
  background-color: #fff;
  border: 1px solid #e3e5e7;
  padding: 16px;
  margin-top: 12px;
  border-radius: 8px;
}

.video-title {
  font-size: 17px;
  font-weight: 600;
  color: #18191c;
  margin: 0 0 14px 0;
  line-height: 1.4;
}

.video-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.author-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.author-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e3e5e7;
}

.author-name {
  line-height: 40px;
  font-size: 15px;
  color: #18191c;
  font-weight: 500;
}

.follow-btn {
  padding: 6px 18px;
  border: 1px solid #fb7299;
  background-color: #fb7299;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.follow-btn:hover {
  background-color: #ff85ad;
  border-color: #ff85ad;
}

.follow-btn.followed {
  background-color: #f1f2f3;
  color: #9499a0;
  border-color: #f1f2f3;
}

.video-stats {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 12px;
  color: #9499a0;
}

.share-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  border: 1px solid #e3e5e7;
  background-color: #fff;
  border-radius: 6px;
  font-size: 12px;
  color: #61666d;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s, background-color 0.2s;
}

.share-btn:hover {
  color: #fb7299;
  border-color: #fb7299;
}

.share-btn.liked {
  border-color: #fb7299;
  color: #fb7299;
  background-color: #fff0f5;
}

.icon-share-svg {
  width: 16px;
  height: 16px;
}

/* 评论区（白色卡片） */
.comment-section {
  background-color: #fff;
  border: 1px solid #e3e5e7;
  padding: 16px;
  margin-top: 12px;
  border-radius: 8px;
}

.comment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #f1f2f3;
}

.comment-title {
  font-size: 15px;
  font-weight: 600;
  color: #18191c;
}

.send-btn-small {
  padding: 5px 14px;
  border: none;
  background-color: #fb7299;
  color: #fff;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
}

.comment-input-wrapper {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.comment-input {
  flex: 1;
  padding: 8px 14px;
  border: 1px solid #e3e5e7;
  border-radius: 6px;
  font-size: 13px;
  color: #18191c;
  outline: none;
  transition: border-color 0.2s;
}

.comment-input::placeholder {
  color: #9499a0;
}

.comment-input:focus {
  border-color: #fb7299;
}

.send-btn {
  padding: 0 22px;
  border: 1px solid #fb7299;
  background-color: #fb7299;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.send-btn:hover {
  background-color: #ff85ad;
  border-color: #ff85ad;
}

.comment-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.comment-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.comment-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid #e3e5e7;
}

.comment-content {
  flex: 1;
  min-width: 0;
}

.comment-author {
  font-size: 13px;
  color: #18191c;
  font-weight: 600;
  margin-bottom: 4px;
}

.comment-text {
  font-size: 13px;
  color: #61666d;
  line-height: 1.5;
  margin-bottom: 4px;
}

.comment-time {
  font-size: 12px;
  color: #9499a0;
}

.comment-like {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border: none;
  background-color: transparent;
  color: #9499a0;
  font-size: 12px;
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.2s;
}

.comment-like:hover {
  color: #fb7299;
}

.icon-like-svg {
  width: 16px;
  height: 16px;
}

/* 右侧推荐区（白色卡片） */
.right-section {
  /* 宽度按比例自适应，最小280px */
  width: 25%;
  min-width: 280px;
  flex-shrink: 0;
}

.recommend-section {
  background-color: #fff;
  border: 1px solid #e3e5e7;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 12px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #18191c;
  margin: 0 0 12px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f2f3;
}

.recommend-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.recommend-item {
  display: flex;
  gap: 12px;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.recommend-item:hover {
  background-color: #f7f7f8;
}

.recommend-cover {
  width: 95px;
  height: 120px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  border: 1px solid #e3e5e7;
}

.recommend-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recommend-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2px 0;
}

.recommend-title {
  font-size: 13px;
  color: #18191c;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.2s;
}

.recommend-item:hover .recommend-title {
  color: #fb7299;
}

.recommend-author {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #9499a0;
}

.recommend-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
}

/* 广告区 */
.ad-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ad-item {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.ad-item img {
  width: 100%;
  height: auto;
  display: block;
}

/* 响应式适配 */
@media (max-width: 1024px) {
  .main-container {
    flex-direction: column;
    width: 100%;
  }

  .right-section {
    width: 100%;
  }

  .recommend-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .replay-page {
    padding: 10px;
  }
  
  .video-meta {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .recommend-list {
    grid-template-columns: 1fr;
  }
}
</style>
